import { createRoot } from 'react-dom/client';
import Pin from './pin.js';

// eslint-disable-next-line no-undef
const createHTMLMapMarker = ({ OverlayView = google.maps.OverlayView, ...args }) => {
  class HTMLMapMarker extends OverlayView {
    constructor() {
      super();
      this.position = args.latlng;
      this.latlng = args.latlng;
      this.markerprops = args.markerprops;
      this.onMouveOver = args.onMouveOver;
      this.zoomOut = args.zoomOut;
      // this.setMap(args.map);
    }

    getVisible() {
      // eslint-disable-next-line no-unused-vars
      const self = this;
      return true;
    }

    createDiv() {
      this.render = false;
      this.div = document.createElement('div');
      this.div.style.position = 'absolute';

      // google.maps.event.addDomListener(this.div, 'mouseover', event => {
      //   google.maps.event.trigger(this, 'click');
      // });
      // const self = this;
      // this.div.addEventListener('mouseover', () => {
      //   if (self.onMouveOver) {
      //     self.onMouveOver({ markerprops: this.markerprops }, true);
      //   }
      // });
      // this.div.addEventListener('mouseout', () => {
      //   if (self.onMouveOver) {
      //     self.onMouveOver({ markerprops: this.markerprops }, false);
      //   }
      // });
    }

    appendDivToOverlay() {
      const panes = this.getPanes();
      panes.floatPane.appendChild(this.div);
    }

    positionDiv() {
      const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
      if (point) {
        this.div.style.left = `${point.x}px`;
        this.div.style.top = `${point.y}px`;
      }
    }

    draw() {
      if (!this.div) {
        this.createDiv();
        this.appendDivToOverlay();
        this.root = createRoot(this.div);
      }
      this.positionDiv();

      if (!this.render) {
        this.root.render(<Pin marker={this.markerprops} latlng={this.latlng} />);
        this.render = true;
      }
    }

    remove() {
      if (this.div) {
        if (this.div.parentNode) this.div.parentNode.removeChild(this.div);
        this.div = null;
        this.setMap(null);
      }
    }

    getPosition() {
      return this.latlng;
    }

    getDraggable() {
      // eslint-disable-next-line no-unused-vars
      const self = this;
      return false;
    }
  }
  return new HTMLMapMarker();
};

export {
  createHTMLMapMarker,
};
export default createHTMLMapMarker;
